<template>
    <div class="full-content" style="background-image:url('assets/img/bg-gaspol-1.jpg');">
        <div class="card bg-card-trans border-0 rounded-0 mobile-ver">
            <div class="mobile-ver-top mobile-ver-top-2">
                <div class="d-flex align-items-center h-100 justify-content-between px-3">
                    <div class="d-flex align-items-center">
                        <a href="javascript:void(0)" class="btn btn-white-naked btn-icon me-md-3 me-2" v-on:click="goToPage('student_rationalization')">
                            <i class="fa-solid fa-arrow-left"></i>
                        </a>
                        <div class="d-block display-tektur h1 m-0">Rasionalisasi</div>
                    </div>
                </div>
            </div>
            <div class="mobile-ver-content--has-simplebar mobile-ver-content-2 full-bottom">
                <div v-if="dataFetch" class="d-block mb-4">
                    <p class="text-center mt-5">Loading...</p>
                </div>

                <div class="px-md-4 px-3 pt-md-4 pt-3" :class="dataFetch ? 'd-none':'d-block'">
                    <img src="assets/img/accent-2.png" class="accent-2">
                    <div class="d-block" v-for="(item, index) in dataEvaluation" :key="index">
                        <div class="row">
                            <div class="col-md-12 col-9">
                                <div class="d-flex align-items-center mb-4">
                                    <div class="d-block me-3">
                                        <div class="avatar">
                                            <span class="avatar-title rounded-circle bg-white text-dark"><i
                                                    class="fa-solid fa-building-columns fa-lg m-0"></i></span>
                                        </div>
                                    </div>
                                    <div class="d-block" style="z-index:1000 !important;">
                                        <div class="d-block h2 m-0 font-bold">{{item.major_fullname}}</div>
                                        <div class="d-block">{{item.university_name}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-4">
                            <div class="col-6">
                                <div class="card bg-dblue border m-0">
                                    <div class="d-block p-3 text-center">
                                        <div class="d-block mb-2 text-sm">Index Nilai</div>
                                        <div class="d-block text-lg display-tektur m-0 text-pink">{{item.index_score}}%</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="card bg-dblue border m-0">
                                    <div class="d-block p-3 text-center">
                                        <div class="d-block mb-2 text-sm">Peluang</div>
                                        <div class="d-block text-lg display-tektur m-0 text-pink">{{item.opportunity}}%</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-6">
                                        <div class="d-block mb-4">
                                            <div class="d-block mb-2 text-sm text-muted">Nama</div>
                                            <div class="d-block font-bold">{{dataUsers.fullname}}</div>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="d-block mb-4">
                                            <div class="d-block mb-2 text-sm text-muted">NIS</div>
                                            <div class="d-block font-bold">{{dataUsers.identity_number}}</div>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="d-block mb-4">
                                            <div class="d-block mb-2 text-sm text-muted">Sekolah</div>
                                            <div class="d-block font-bold">{{ dataUsers.school_name }}</div>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="d-block mb-4">
                                            <div class="d-block mb-2 text-sm text-muted">Akreditasi Sekolah</div>
                                            <div class="d-block font-bold">{{ dataUsers.accreditation }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <div class="card bg-dblue1 m-0">
                                            <div class="d-block p-3 text-center">
                                                <div class="d-block mb-2 text-sm">Nilai rata-rata saya</div>
                                                <div class="d-block text-md display-tektur m-0 text-pink">{{item.avg_score_subject}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="card bg-dblue1 m-0">
                                            <div class="d-block p-3 text-center">
                                                <div class="d-block mb-2 text-sm">Nilai prasyarat saya</div>
                                                <div class="d-block text-md display-tektur m-0 text-pink">{{item.avg_score_prerequisite}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-6">
                                        <div class="d-block text-pink h3">SNBP</div>
                                        <div class="d-block overflow-hidden pb-2 mb-2 border-bottom">
                                            <div class="block-ellipsis">Nilai Posibilitas Minimum</div>
                                            <div class="d-flex align-items-center">
                                                <i class="fa-solid fa-caret-right me-2 text-neon fa-lg"></i>
                                                <div class="display-tektur text-md m-0">{{item.statistic.pg_rapor}}</div>
                                            </div>
                                        </div>
                                        <div class="d-block overflow-hidden pb-2 mb-2 border-bottom">
                                            <div class="block-ellipsis">Peminat</div>
                                            <div class="d-flex align-items-center">
                                                <i class="fa-solid fa-caret-right me-2 text-neon fa-lg"></i>
                                                <div class="display-tektur text-md m-0">{{item.statistic.snbp_applicants}}</div>
                                            </div>
                                        </div>
                                        <div class="d-block overflow-hidden pb-2 mb-2 border-bottom">
                                            <div class="block-ellipsis">Kuota</div>
                                            <div class="d-flex align-items-center">
                                                <i class="fa-solid fa-caret-right me-2 text-neon fa-lg"></i>
                                                <div class="display-tektur text-md m-0">{{item.statistic.snbp_quota}}</div>
                                            </div>
                                        </div>
                                        <div class="d-block overflow-hidden pb-2 mb-2 border-bottom">
                                            <div class="block-ellipsis">Persaingan</div>
                                            <div class="d-flex align-items-center">
                                                <i class="fa-solid fa-caret-right me-2 text-neon fa-lg"></i>
                                                <div class="display-tektur text-md m-0">1:{{ item.statistic.snbp_comparison }}</div>
                                            </div>
                                        </div>
                                        <div class="d-block overflow-hidden pb-2 mb-2 border-bottom">
                                            <div class="block-ellipsis">Skor Index SNBP</div>
                                            <div class="d-flex align-items-center">
                                                <i class="fa-solid fa-caret-right me-2 text-neon fa-lg"></i>
                                                <div class="display-tektur text-md m-0">{{ item.index_snbp }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="d-block text-pink h3">SNBT</div>
                                        <div class="d-block overflow-hidden pb-2 mb-2 border-bottom">
                                            <div class="block-ellipsis">Nilai Posibilitas Minimum</div>
                                            <div class="d-flex align-items-center">
                                                <i class="fa-solid fa-caret-right me-2 text-neon fa-lg"></i>
                                                <div class="display-tektur text-md m-0">{{ item.statistic.pg_utbk }}</div>
                                            </div>
                                        </div>
                                        <div class="d-block overflow-hidden pb-2 mb-2 border-bottom">
                                            <div class="block-ellipsis">Peminat</div>
                                            <div class="d-flex align-items-center">
                                                <i class="fa-solid fa-caret-right me-2 text-neon fa-lg"></i>
                                                <div class="display-tektur text-md m-0">{{item.statistic.snbt_applicants}}</div>
                                            </div>
                                        </div>
                                        <div class="d-block overflow-hidden pb-2 mb-2 border-bottom">
                                            <div class="block-ellipsis">Kuota</div>
                                            <div class="d-flex align-items-center">
                                                <i class="fa-solid fa-caret-right me-2 text-neon fa-lg"></i>
                                                <div class="display-tektur text-md m-0">{{ item.statistic.snbt_quota }}</div>
                                            </div>
                                        </div>
                                        <div class="d-block overflow-hidden pb-2 mb-2 border-bottom">
                                            <div class="block-ellipsis">Persaingan</div>
                                            <div class="d-flex align-items-center">
                                                <i class="fa-solid fa-caret-right me-2 text-neon fa-lg"></i>
                                                <div class="display-tektur text-md m-0">1:{{ item.statistic.snbt_comparison }}</div>
                                            </div>
                                        </div>
                                        <div class="d-block overflow-hidden pb-2 mb-2 border-bottom">
                                            <div class="block-ellipsis">Skor Index SNBP</div>
                                            <div class="d-flex align-items-center">
                                                <i class="fa-solid fa-caret-right me-2 text-neon fa-lg"></i>
                                                <div class="display-tektur text-md m-0">{{ item.index_snbt }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12" v-if="dataMajorRank.total_data > 0">
                                        <div class="d-block overflow-hidden pb-2 mb-2 border-bottom">
                                            <div class="block-ellipsis">Peringkat Jurusan di Sekolah</div>
                                            <div class="d-flex align-items-center">
                                                <i class="fa-solid fa-caret-right me-2 text-neon fa-lg"></i>
                                                <div v-if="dataMajorRank.my_rank != '-'" class="display-tektur text-md m-0">{{ dataMajorRank.my_rank }} dari {{ dataMajorRank.total_data }}</div>
                                                <div v-if="dataMajorRank.my_rank == '-'" class="display-tektur text-md m-0">Peringkat belum diketahui</div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-body">
                                <RadarChart :width="310" :height="310" :chart-data="dataChartRecap"/>
                                <small>
                                    Keterangan:
                                    <ul class="mt-3" v-for="(labelItem, labelIndex) in description_labels" :key="labelIndex">
                                        <li>{{ labelItem }}</li>
                                    </ul>
                                </small>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-body">
                                <div class="d-block font-bold text-pink mb-3">Rekap Perbandingan Nilai</div>
                                <table class="table table-th-0 table-sm-td table-sm-th m-0 text-sm">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th class="text-center text-sm pb-3" style="font-size:10px;">Pencapaian</th>
                                            <th class="text-center text-sm pb-3" style="font-size:10px;">Saran</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in dataScoreComparison" :key="index" :class="item.prerequisite == 1 ? 'highlight-success':''">
                                            <td class="w-100 td-wrap font-bold m-0">{{ item.subject_name }}</td>
                                            <td class="text-center">
                                                <div class="box-score box-warning">
                                                    <span>{{ item.average_score }}</span>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <div class="box-score box-pink">
                                                    <span>{{ item.suggest_score }}</span>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="d-flex mb-4 ps-1">
                            <div class="d-flex align-items-center me-4 mb-2">
                                <div class="box-skew-12 me-2 bg-pink-2"></div>
                                <div class="d-block">Saran</div>
                            </div>
                            <div class="d-flex align-items-center me-4 mb-2">
                                <div class="box-skew-12 me-2 bg-warning"></div>
                                <div class="d-block">Pencapaian</div>
                            </div>
                            <div class="d-flex align-items-center me-4 mb-2">
                                <div class="box-skew-12 me-2 bg-neon-green"></div>
                                <div class="d-block">Mapel Prasyarat</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div :class="dataFetch ? 'd-none':'d-block'" class="table-sticky-left-1 border-top mb-4">
                    <div class="block-sticky border-end">
                        <table
                            class="table table-th-0 table-td-border table-th-border table-sm-td table-sm-th table-th-style-1 m-0">
                            <thead>
                                <tr class="th-1">
                                    <th class="text-pink block-sticky-th ps-4" rowspan="2">Tabel Detail Perbandingan
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in dataScoreComparison" :key="index">
                                    <td class="font-bold block-sticky-td px-4">
                                        <div class="block-ellipsis">{{item.subject_name}}</div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div data-simplebar class="block-scroll-wrapper bg-dblue2 mb-4">
                        <div class="block-scroll ">
                            <!-- Block Semester -->
                            <div class="block-scroll-item" v-for="(itemSemester, indexSemester) in total_semester" :key="indexSemester">
                                <table
                                    class="table table-th-0 table-td-border table-th-border table-sm-td table-sm-th table-th-style-1 m-0">
                                    <thead>
                                        <tr class="th-1">
                                            <th class="text-center" colspan="3">Semester {{itemSemester}}</th>
                                        </tr>
                                        <tr>
                                            <th class="text-center">Nilai</th>
                                            <th class="text-center">Saran<br>Minimal</th>
                                            <th class="text-center">Saran<br>Ideal</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in dataScoreComparison" :key="index">
                                            <td class="text-center">
                                                <div v-if="item.list_score[itemSemester].score" class="box-score box-score-sm-2" :class="item.list_score[itemSemester].class_btn">
                                                    <span>{{ item.list_score[itemSemester].score}}</span>
                                                </div>
                                                <span v-if="!item.list_score[itemSemester].score">-</span>
                                            </td>
                                            <td class="text-center">
                                                <div v-if="item.list_score[itemSemester].min_suggestion" class="box-score box-score-sm-2" :class="item.list_score[itemSemester].class_btn">
                                                    <span>{{ item.list_score[itemSemester].min_suggestion}}</span>
                                                </div>
                                                <span v-if="!item.list_score[itemSemester].min_suggestion">-</span>
                                            </td>
                                            <td class="text-center">
                                                <div v-if="item.list_score[itemSemester].ideal_suggestion" class="box-score box-score-sm-2" :class="item.list_score[itemSemester].class_btn">
                                                    <span>{{ item.list_score[itemSemester].ideal_suggestion}}</span>
                                                </div>
                                                <span v-if="!item.list_score[itemSemester].ideal_suggestion">-</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                </div>
                <div :class="dataFetch ? 'd-none':'d-block'" class="hide-767 mt-5">
                    <div class="d-block px-md-4 px-3 pb-4">
                        <div class="d-block text-end text-sm">
                            Gunakan <span class="badge bg-white font-bold mx-1">Shift + Scroll</span> untuk geser tabel
                            diatas
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import RadarChart from '../../components/chart/Radar.vue'
  export default {
    name: 'StudentRationalizationDetail',
    data() {
        return {
            dataFetch       : false,
            dataUsers  : [],
            dataEvaluation  : [],
            dataScoreComparison  : [],
            dataChartRecap : [],
            dataMajorRank : [],
            description_labels : [],
            total_semester  : 5,
        }
    },
    components: {
      RadarChart
    },
    created() {
        if(this.$route.query.type == 'major' || this.$route.query.type == 'group_subject') {
            this.getEvaluationMajor();
        } else {
            this.getEvaluation();
        }
    },
    methods: {
        goToPage: function(params=null) {
            this.$router.push( {
                name : params
            })            
        },
        getEvaluation: function() {
            this.dataFetch      = true;
            this.dataEvaluation = [];
            this.dataScoreComparison = [];
            this.dataUsers = [];
            let uri         = process.env.VUE_APP_APIHOST+'rationalization/evaluation';
            this.$http.get(uri,{
                params : {
                    id    : this.$route.params.id,
                    code    : this.$route.params.code,
                    statistic : 1
                }
            }).then(res => {
                this.dataFetch      = false;
                if(res.data.status) {
                    this.dataUsers              = res.data.data.users;
                    this.dataEvaluation         = res.data.data.evaluation;
                    this.dataScoreComparison    = res.data.data.score_comparison;
                    this.dataChartRecap         = res.data.data.chart_recap;
                    this.dataMajorRank          = res.data.data.major_rank;
                    this.description_labels     = res.data.data.description_labels;
                }
             });
        },
        getEvaluationMajor: function() {
            this.dataFetch      = true;
            this.dataEvaluation = [];
            this.dataScoreComparison = [];
            this.dataUsers = [];
            let uri         = process.env.VUE_APP_APIHOST+'rationalization/evaluation-alt-major';
            this.$http.get(uri,{
                params : {
                    id    : this.$route.params.id,
                    code    : this.$route.params.code,
                    type : this.$route.query.type,
                    statistic : 1
                }
            }).then(res => {
                this.dataFetch      = false;
                if(res.data.status) {
                    this.dataUsers              = res.data.data.users;
                    this.dataEvaluation         = res.data.data.evaluation;
                    this.dataScoreComparison    = res.data.data.score_comparison;
                    this.dataChartRecap         = res.data.data.chart_recap;
                    this.dataMajorRank          = res.data.data.major_rank;
                    this.description_labels          = res.data.data.description_labels;
                }
             });
        }
    }
  }
</script>